import { createSchema, ZodOutputFor } from "../zod-utils";
import { PlainMessage } from "@bufbuild/protobuf";
import { z } from "zod/v3";
import { ResponseStatus, responseStatusSchema } from "./util/responseStatus";
import { OpenHipPlanByTaskIdResponse as ProtoOpenHipPlanByTaskIdResponse } from "@opstel/gen/knop/ui/v1/api/hip_pb";

export interface OpenHipPlanByTaskIdResponse {
  status: ResponseStatus;
  instanceId: string;
  correlationOperationId: string;
  correlationParentId: string;
  correlationCurrentId: string;
}
export const openHipPlanByTaskIdResponseSchema = createSchema<
  OpenHipPlanByTaskIdResponse,
  PlainMessage<ProtoOpenHipPlanByTaskIdResponse>
>({
  status: responseStatusSchema,
  description: z.string(),
  instanceId: z.string(),
  correlationOperationId: z.string(),
  correlationParentId: z.string(),
  correlationCurrentId: z.string(),
}).refine(
  (message) =>
    message.status !== "SUCCESS" || z.string().uuid().safeParse(message.instanceId).success,
  {
    message: "instance should have a valid guid as instance id",
  },
) as ZodOutputFor<OpenHipPlanByTaskIdResponse>;
